/** Module-level metrics for PerformanceStats to read. No store overhead. */
export const vehicleLayerMetrics = {
  lastSerializationMs: 0,
  setDataCount: 0,
  renderedFeatures: 0,
};
